import React from "react";
import Login from "../../../components/login/Login";
import { doInitClient } from "../../../store/actions/auth";

const LoginClient = () => {
  return <Login doInit={doInitClient} />;
};

export default LoginClient;
